module.exports = __webpack_public_path__ + "static/img/01_04.74abde6b.jpg";